export const appRoutes = {
  HOME: '/',
  SIGN_IN: '/sign-in',
  PRODUCER: '/producer',
  CONSUMER: '/consumer',
  SETTINGS: '/settings',
  ERROR_403: '/forbidden',
  ERROR_401: '/access-denied',
  ERROR_404: '*',
};
